import { render } from "./PercentInput.vue?vue&type=template&id=489afde6&scoped=true&ts=true"
import script from "./PercentInput.vue?vue&type=script&lang=ts"
export * from "./PercentInput.vue?vue&type=script&lang=ts"

import "./PercentInput.vue?vue&type=style&index=0&id=489afde6&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489afde6"]])

export default __exports__